
module.exports = {
  title: '龙翼客车运营管理平台',
  // baseUrl: '//172.20.3.11:7229/',//海外独立
  baseUrl: '//182.61.36.159:8280/longyi/',//海外独立
  //  socketServer: "172.20.9.7:8280/socket",//海外独立
  socketServer: "182.61.36.159:8280/socket",//海外独立
  //是否支持当天数据查询
  supportTodayDataQuery: false,
  routeStartTime: {}
}


